import { ResolveFn, Router } from '@angular/router';
import { QuotationService } from '../../services/quotation/quotation.service';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuotationDetails } from '../../models/quotation';
import { forkJoin, tap } from 'rxjs';
import { RFQGroup } from '../../models/rfq';
import { ApiResponse } from '../../Interfaces/apiResponse.interface';
import { NavigationPipe } from '../../pipes/navigation/navigation.pipe';
import { Path } from '../../constants/paths.constant';
import { RfqService } from '../../services/rfq/rfq.service';

interface QuotationDetailsResolvedData {
  details: ApiResponse<QuotationDetails>;
  groups: ApiResponse<RFQGroup[]>;
}

export const quotationDetailsResolver: ResolveFn<
  QuotationDetailsResolvedData
> = (route, state) => {
  const router = inject(Router);
  const rfqService = inject(RfqService);
  const navigation = new NavigationPipe();
  const quotationService = inject(QuotationService);
  const destroyRef = inject(DestroyRef);
  const rfqId = route.params['rfqId'];
  const quotationId = route.params['quotationId'];
  const isBuyer = state.url.includes('buyer');

  return forkJoin({
    details: isBuyer
      ? quotationService.getBuyerQuotationDetails(rfqId, quotationId)
      : quotationService.getSupplierQuotationDetails(rfqId, quotationId),
    groups: isBuyer
      ? quotationService.getBuyerQuotationDetailsGroups(rfqId, quotationId)
      : rfqService.getSupplierReceivedRfqGroups(rfqId),
  }).pipe(
    takeUntilDestroyed(destroyRef),
    tap(({ details, groups }) => {
      if (!details.data || !groups.data)
        router.navigate([
          navigation.transform(
            isBuyer
              ? `${Path.BUYER}/${Path.QUOTATION.QUOTATION_RFQ}`
              : `${Path.SUPPLIER}/${Path.QUOTATION.QUOTATION_RFQ}`
          ),
        ]);
    })
  );
};
